<template>
    <VButton
        v-gtm:@click
        v-gtm:label="buttonGtmLabel"
        block
        color="accent"
        textColor="primary"
        class="notranslate button"
        v-on:click="onClick"
    >
        <span class="title">{{ title }}</span>
        <Count
            v-if="count"
            class="itemCount"
            bgColor="brandColor"
            textColor="white"
            borderColor="brandColor"
            v-bind:number="count"
        />
    </VButton>
    <div class="info">
        <span class="noBets">{{ i18n.t('no_bet_selected_msg') }}</span>
        <span class="infoItem">{{ i18n.t('no_bet_selected_ins') }}</span>
    </div>
    <slot name="message" />
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import Count from '@/components/common/Count.vue';
    import VButton from '@/components/common/button/VButton.vue';
    import { i18n } from '@/core/lib/i18n';

    defineProps({
        title: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            default: 0,
        },
        onClick: {
            type: Function as PropType<() => void>,
            required: true,
        },
        buttonGtmLabel: {
            type: String,
            required: true,
        },
    });

</script>

<style lang="scss" scoped>
    @import "@/components/betSlip/NoBetSlip";
</style>
